import React from "react";
import { getDeliveryMethodTitle, getDeliveryDistance, getTotalDeliveryCost, } from "../utils/delivery";
import { formatPrice } from "../utils/helpers";
import { DeliveryType } from "@wayke-se/ecom";
export default (props) => {
    if (!props.data.interact.delivery.type ||
        props.data.delivery.type === DeliveryType.None)
        return null;
    const deliveryOptions = props.orderOptions.getDeliveryOptions() || [];
    const deliveryOption = deliveryOptions.find((option) => option.type === props.data.delivery.type);
    if (!deliveryOption)
        return null;
    const address = props.getAddress();
    const addressDistance = address !== null ? address.distance : undefined;
    const distance = getDeliveryDistance(addressDistance, deliveryOption);
    const totalDeliveryCost = getTotalDeliveryCost(addressDistance, deliveryOption);
    const hasUnitPrice = typeof deliveryOption.unitPrice === "number" &&
        deliveryOption.unitPrice > 0;
    return (React.createElement("div", { className: "repeat-m" },
        React.createElement("div", { "data-ecom-productcard": "" },
            React.createElement("div", { className: "product-card-content-section" },
                React.createElement("div", { className: "product-card-content" },
                    React.createElement("div", { className: "product-card-title" },
                        React.createElement("div", { className: "product-card-heading" }, "Leverans")),
                    React.createElement("div", { className: "m-t-mini" }, getDeliveryMethodTitle(deliveryOption.type)),
                    React.createElement("div", { className: "m-t-mini text-dark-lighten" },
                        totalDeliveryCost && (React.createElement(React.Fragment, null,
                            formatPrice(totalDeliveryCost),
                            " kr",
                            React.createElement("span", { className: "m-l-mini" },
                                "(Ber\u00E4knat p\u00E5 ",
                                distance,
                                " ",
                                deliveryOption.unit,
                                " \u00E1",
                                " ",
                                formatPrice(deliveryOption.unitPrice),
                                " ",
                                "kr/",
                                deliveryOption.unit,
                                " och en startkostnad p\u00E5",
                                " ",
                                formatPrice(deliveryOption.startupCost),
                                " ",
                                "kr)"))),
                        !totalDeliveryCost && hasUnitPrice && (React.createElement(React.Fragment, null,
                            "Startkostnad:",
                            " ",
                            formatPrice(deliveryOption.startupCost),
                            " kr +",
                            formatPrice(deliveryOption.unitPrice),
                            " kr/",
                            deliveryOption.unit)),
                        !hasUnitPrice &&
                            deliveryOption.startupCost > 0 && (React.createElement(React.Fragment, null,
                            formatPrice(deliveryOption.startupCost),
                            " ",
                            "kr"))))))));
};
